import React from 'react'

export default function Svg({ name, ...rest }) {
  const getPath = x => {
    switch (x) {
      case 'defense':
        return (
          <>
            <path
              d='M23.152 44.392H10.476V5.846h12.411c3.406 0 6.47.771 9.194 2.313 2.714 1.543 4.835 3.724 6.362 6.543 1.526 2.811 2.298 5.965 2.313 9.459v1.783c0 3.527-.743 6.688-2.229 9.483-1.494 2.796-3.594 4.985-6.302 6.567-2.715 1.582-5.739 2.382-9.073 2.398zm-.265-31.377h-3.121v24.232h3.229c2.667 0 4.715-.949 6.146-2.844 1.43-1.904 2.144-4.723 2.144-8.459v-1.675c0-3.726-.714-6.534-2.144-8.422-1.431-1.888-3.515-2.832-6.254-2.832z'
              fill='#333'
            />
          </>
        )
      case 'nba':
        return (
          <>
            <g>
              <path
                d='M29.89 45.476c.047-.754.028-1.008-.075-1.13-.076-.095-.132-.387-.132-.717 0-.499-.076-.687-.66-1.837-.63-1.224-.65-1.29-.537-1.601.104-.292.085-.386-.14-.914-.227-.527-.33-.64-.943-1.046-1.177-.8-2.129-1.61-3.712-3.174-1.761-1.752-3.23-3.674-4.587-6.02-.471-.82-.509-.847-.923-.847-.311 0-.688-.274-.688-.5 0-.066-.386-.904-.848-1.874-1.215-2.506-1.319-3.034-.951-4.861.216-1.083.263-1.178.725-1.686.49-.537.415-.697-.386-.773-1.065-.103-1.055-.103-1.281-.782-.113-.339-.198-.716-.198-.848 0-.433.49-1.79 1.159-3.23.367-.783.829-1.847 1.036-2.375.735-1.855 1.752-3.344 2.572-3.758.33-.17.96-.292 2.854-.565 1.055-.151 1.13-.227 1.281-1.32.085-.63.075-.734-.085-1.007-.122-.198-.188-.471-.188-.782 0-.443.028-.5.282-.631.255-.132.283-.198.283-.565 0-.886.179-1.376.678-1.866a5.8 5.8 0 0 0 .349-.358h-6.51a4 4 0 0 0-4.003 4.004v40.846a4 4 0 0 0 4.003 4.004h11.917a2.303 2.303 0 0 0-.226-.377c-.264-.387-.264-.255-.066-3.41z'
                fill='#0e499d'
              />
              <path
                d='M30.436.41H26.99c.037.037.084.084.14.122.425.282 1.075.951 1.178 1.224.151.406.123.952-.103 1.536-.123.34-.18.64-.142.82.066.339-.263 1.045-.65 1.403-.14.132-.339.405-.442.603a4.999 4.999 0 0 1-.566.782c-.207.226-.367.49-.348.575.019.084.264.292.556.442.282.151.716.462.951.67s.716.593 1.065.837c1.253.886 1.855 2.403 1.865 4.692 0 1.017.5 3.391.857 4.098.49.96.66 1.488.81 2.449.198 1.234.198 1.243.594 1.413.377.16 1.347.942 1.347 1.093 0 .047.094.226.216.395l.132.18V4.412A4.014 4.014 0 0 0 30.436.409zm3.947 26.819c0 .047-.207.32-.47.603-1.8 1.968-4.88 1.526-6.01-.858-.274-.574-.302-.725-.302-1.535 0-.782.038-.97.254-1.441a3.952 3.952 0 0 1 1.752-1.8c.33-.16.622-.33.65-.367.029-.038-.273-.716-.668-1.507-.905-1.828-1.008-2.148-1.423-4.334a90.924 90.924 0 0 0-.377-1.912c-.075-.207-.339-.132-.998.31l-.64.425-.575 1.47c-.32.81-.585 1.591-.585 1.742 0 .17.095.358.245.5.377.357.48.612 1.13 2.863.472 1.658.585 2.139.51 2.308-.076.16-.029.509.188 1.432.32 1.356.443 2.072.593 3.542.151 1.488.311 1.96 1.178 3.467.575.998.754 1.592 1.159 3.928.188 1.074.367 2.016.414 2.091s.236.377.415.65c.508.763.593 1.112.405 1.846-.085.34-.18.839-.208 1.121-.066.566.142 1.932.368 2.487.075.189.122.424.094.519-.028.103.085.602.245 1.111.5 1.602.48 2.28-.094 3.005-.104.132-.16.207-.189.254a4.011 4.011 0 0 0 3.015-3.88V27.143c-.057.019-.076.047-.076.085z'
                fill='#d30529'
              />
              <path
                d='M15.684 40.247h1.62l.933 4.126h.019v-4.126h1.357v6.698H18.02l-.961-4.135h-.02v4.135h-1.356v-6.698zM20.31 40.247h2.185c1.036 0 1.517.67 1.517 1.668 0 .716-.255 1.347-.876 1.498v.018c.734.085 1.026.839 1.026 1.526 0 1.169-.47 1.979-1.676 1.979H20.3v-6.689zm1.45 2.629h.349c.292 0 .461-.32.461-.679 0-.376-.16-.697-.461-.697h-.349v1.376zm0 2.816h.405c.264 0 .519-.282.519-.829 0-.518-.245-.81-.519-.81h-.405v1.64zM25.613 40.247h1.818l1.357 6.698h-1.536l-.15-1.177h-1.15l-.15 1.177h-1.545l1.356-6.698zm.923 1.366h-.018l-.396 2.845h.81l-.396-2.845z'
                fill='#fff'
              />
            </g>
          </>
        )
      case 'star':
        return (
          <>
            <path
              d='M25.003 1.476l6.03 17.351 18.367.374L34.762 30.3l5.318 17.582L25.002 37.39 9.924 47.88l5.32-17.581L.606 19.2l18.366-.373z'
              fill='#FFE41A'
            />
          </>
        )
      default:
        return <></>
    }
  }

  return (
    <svg viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg' {...rest}>
      {getPath(name)}
    </svg>
  )
}
